<template>
    <div class="content favorites">
        <nav aria-label="breadcrumb" role="navigation">
            <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <router-link :to="{ name: 'Search' }">
                Dashboard
                </router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
                My favorites
            </li>
            </ol>
        </nav>
       <div class="favorites_wrapper">
        <div class="row_clip">
            <div class="title_left"><h2>My Favorites </h2></div>
            <div class="shorting_right">
                <span class="short_btn">Short By Date <svg aria-hidden="true" width="6px" focusable="false" data-prefix="fal" data-icon="arrows-v" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512" class="svg-inline--fa fa-arrows-v fa-w-6 fa-2x"><path fill="currentColor" d="M181.415 399.959c-4.686-4.686-12.284-4.686-16.971 0L113 451.887V60.113l51.444 51.928c4.686 4.686 12.284 4.686 16.971 0l7.07-7.071c4.686-4.686 4.686-12.284 0-16.97l-84-84.485c-4.686-4.686-12.284-4.686-16.971 0L3.515 88c-4.686 4.686-4.686 12.284 0 16.97l7.07 7.071c4.686 4.686 12.284 4.686 16.971 0L79 60.113v391.773l-51.444-51.928c-4.686-4.686-12.284-4.686-16.971 0l-7.07 7.071c-4.686 4.686-4.686 12.284 0 16.97l84 84.485c4.686 4.687 12.284 4.687 16.971 0l84-84.485c4.686-4.686 4.686-12.284 0-16.97l-7.071-7.07z" class=""></path></svg></span>
                <span class="short_btn">Short By Date A-Z <svg aria-hidden="true" width="6px" focusable="false" data-prefix="fal" data-icon="arrows-v" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512" class="svg-inline--fa fa-arrows-v fa-w-6 fa-2x"><path fill="currentColor" d="M181.415 399.959c-4.686-4.686-12.284-4.686-16.971 0L113 451.887V60.113l51.444 51.928c4.686 4.686 12.284 4.686 16.971 0l7.07-7.071c4.686-4.686 4.686-12.284 0-16.97l-84-84.485c-4.686-4.686-12.284-4.686-16.971 0L3.515 88c-4.686 4.686-4.686 12.284 0 16.97l7.07 7.071c4.686 4.686 12.284 4.686 16.971 0L79 60.113v391.773l-51.444-51.928c-4.686-4.686-12.284-4.686-16.971 0l-7.07 7.071c-4.686 4.686-4.686 12.284 0 16.97l84 84.485c4.686 4.687 12.284 4.687 16.971 0l84-84.485c4.686-4.686 4.686-12.284 0-16.97l-7.071-7.07z" class=""></path></svg></span>
            </div>
        </div>
        <div class="row_clip">
            <div class="check_list">
            <ul>
                <li>
                    <label for="checkbox-companies" class="box_list">Companies
                    <input id="checkbox-companies" type="checkbox" checked="checked">
                    <span class="checkmark"></span>
                    </label>
                </li>
                <li>
                    <label for="checkbox-companies" class="box_list">Industries
                    <input id="checkbox-companies" type="checkbox">
                    <span class="checkmark"></span>
                    </label>
                </li>
                <li>
                    <label for="checkbox-areas" class="box_list">Areas
                    <input id="checkbox-areas" type="checkbox" >
                    <span class="checkmark"></span>
                    </label>
                </li>
                <li>
                    <label for="checkbox-sales-classes" class="box_list">Sales Classes
                    <input id="checkbox-sales-classes" type="checkbox">
                    <span class="checkmark"></span>
                    </label>
                </li>
                <li>
                    <label for="checkbox-product-types" class="box_list">Product Types
                    <input id="checkbox-product-types" type="checkbox">
                    <span class="checkmark"></span>
                    </label>
                </li>
            </ul>
            </div>
        </div>
         <div class="row_clip">
            <div class="category_list_main">
                <div class="category_list_sub green">
                <h3><i class="md-icon md-icon-font md-theme-default"> business</i> Companies <span> ( 4 items )</span></h3>
                <ul>
                    <li>
                    <strong>Company Name</strong>
                    <small>Company Address</small>
                    <span>
                    <i class="md-icon md-icon-font md-theme-default"> close</i>
                    </span>
                    </li>
                      <li>
                    <strong>Company Name</strong>
                    <small>Company Address</small>
                    <span>
                    <i class="md-icon md-icon-font md-theme-default"> close</i>
                    </span>
                    </li>
                      <li>
                    <strong>Company Name</strong>
                    <small>Company Address</small>
                    <span>
                    <i class="md-icon md-icon-font md-theme-default"> close</i>
                    </span>
                    </li>
                      <li>
                    <strong>Company Name</strong>
                    <small>Company Address</small>
                    <span>
                    <i class="md-icon md-icon-font md-theme-default"> close</i>
                    </span>
                    </li>
                </ul>
                </div>
                <div class="category_list_sub blue">
                <h3><i class="md-icon md-icon-font md-theme-default"> business_center </i> Industries <span>( 8 items )</span></h3>
                <ul>
                    <li>
                    <strong>Company Name</strong>
                    <small>Company Address</small>
                    <span>
                    <i class="md-icon md-icon-font md-theme-default"> close</i>
                    </span>
                    </li>
                      <li>
                    <strong>Company Name</strong>
                    <small>Company Address</small>
                    <span>
                    <i class="md-icon md-icon-font md-theme-default"> close</i>
                    </span>
                    </li>
                      <li>
                    <strong>Company Name</strong>
                    <small>Company Address</small>
                    <span>
                    <i class="md-icon md-icon-font md-theme-default"> close</i>
                    </span>
                    </li>
                      <li>
                    <strong>Company Name</strong>
                    <small>Company Address</small>
                    <span>
                    <i class="md-icon md-icon-font md-theme-default"> close</i>
                    </span>
                    </li>
                     <li>
                    <strong>Company Name</strong>
                    <small>Company Address</small>
                    <span>
                    <i class="md-icon md-icon-font md-theme-default"> close</i>
                    </span>
                    </li>
                     <li>
                    <strong>Company Name</strong>
                    <small>Company Address</small>
                    <span>
                    <i class="md-icon md-icon-font md-theme-default"> close</i>
                    </span>
                    </li>
                     <li>
                    <strong>Company Name</strong>
                    <small>Company Address</small>
                    <span>
                    <i class="md-icon md-icon-font md-theme-default"> close</i>
                    </span>
                    </li>
                     <li>
                    <strong>Company Name</strong>
                    <small>Company Address</small>
                    <span>
                    <i class="md-icon md-icon-font md-theme-default"> close</i>
                    </span>
                    </li>
                </ul>
                </div>
            </div>
        </div>
       </div>
    </div>
    </template>
    <script>
    export default {
        name: 'Favorites',
        components: {},
    }
    </script>
    <style>
    .favorites .favorites_wrapper{padding:0 15px;}
    .favorites .favorites_wrapper .row_clip{display:flex;width:100%;}
    .favorites .favorites_wrapper .title_left{width:50%;}
    .favorites .favorites_wrapper .title_left h2{font-size:30px;font-weight:600;color:#153b62;}
    .favorites .favorites_wrapper .shorting_right{display:flex;justify-content: flex-end;align-items: center;width:50%;}
    .favorites .favorites_wrapper .shorting_right .short_btn{border:1px solid #6e757b;padding:4px 10px;margin:0 5px;font-size:12px;background:#fff;display:flex;justify-content: flex-end;cursor:pointer;}
    .favorites .favorites_wrapper .shorting_right .short_btn svg{margin:0 0 0 15px;}
    
    
    .favorites .favorites_wrapper ul, .favorites .favorites_wrapper li{margin:0;list-style:none;padding:0;}
    .favorites .favorites_wrapper .check_list {width:100%;}
    .favorites .favorites_wrapper .check_list ul{display:flex;flex-wrap:wrap;margin:0 -5px;}
    .favorites .favorites_wrapper .check_list ul li{flex: 1 1 220px;padding:5px;font-weight:600;color:#fff;position:relative;max-width:320px;}
    .favorites .favorites_wrapper .check_list ul li::after{display: block;content: "";width: 1px;opacity: .4;height: 100%;position: absolute;left: 71px;top: 0;background: #fff;}
    .favorites .favorites_wrapper .check_list ul li:first-child .box_list{background:#99cc67;}
    .favorites .favorites_wrapper .check_list ul li:nth-child(2) .box_list{background:#3b7ef1;}
    .favorites .favorites_wrapper .check_list ul li:nth-child(3) .box_list{background:#f1a80b;}
    .favorites .favorites_wrapper .check_list ul li:nth-child(4) .box_list{background:#0bc4e0;}
    .favorites .favorites_wrapper .check_list ul li:nth-child(5) .box_list{background:#ff6634;}
    .favorites .favorites_wrapper .check_list .box_list{display:block;position:relative;padding-left:35px;cursor:pointer;font-size:18px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;padding:23px 10px 23px 80px;}
    .favorites .favorites_wrapper .check_list .box_list input{position:absolute;opacity:0;cursor:pointer;height:0;width:0}
    .favorites .favorites_wrapper .check_list .checkmark{position:absolute;top:25px;left:25px;height:20px;width:20px;background-color:#fff}
    .favorites .favorites_wrapper .check_list .box_list:hover input ~ .checkmark{background-color:#fff}
    .favorites .favorites_wrapper .check_list .box_list input:checked ~ .checkmark{background-color:#fff}
    .favorites .favorites_wrapper .check_list .checkmark:after{content:"";position:absolute;display:none}
    .favorites .favorites_wrapper .check_list .box_list input:checked ~ .checkmark:after{display:block}
    .favorites .favorites_wrapper .check_list .box_list .checkmark:after{left:7px;top:3px;width:6px;height:12px;border:solid #123a5d;border-width:0 3px 3px 0;-webkit-transform:rotate(45deg);-ms-transform:rotate(45deg);transform:rotate(45deg)}
    
    .favorites .favorites_wrapper .category_list_main{width:100%;background:#fff;-webkit-box-shadow: -1px 1px 5px 0px rgba(0,0,0,0.25);
    -moz-box-shadow: -1px 1px 5px 0px rgba(0,0,0,0.25);
    box-shadow: -1px 1px 5px 0px rgba(0,0,0,0.25);margin:35px 0 0;} 
    
    .favorites .favorites_wrapper .category_list_sub{padding:40px;border-bottom:1px solid #ccc;}
    .favorites .favorites_wrapper .category_list_sub h3{padding:0;margin:0 0 20px 0;font-size:20px;font-weight:600;color:#555;color:#153b62;}
    .favorites .favorites_wrapper .category_list_sub h3 span{font-size:14px;font-weight:400;color:#999;}
    .favorites .favorites_wrapper .category_list_sub h3 i{color: #555;font-size: 32px !important;margin-right: 14px;float: left;}
    .favorites .favorites_wrapper .category_list_sub ul li:hover{background:#f6f6f6;}
    .favorites .favorites_wrapper .category_list_sub ul{display:flex;flex-wrap:wrap;}
    .favorites .favorites_wrapper .category_list_sub ul li{width:24%;margin:0 1% 1% 0;padding:15px 20px;border:1px solid #cdcdcd;position:relative;cursor:pointer;}
    .favorites .favorites_wrapper .category_list_sub ul li span{position: absolute;top: 5px;right: 5px;width: 20px;height: 20px;background: #ff6635;display: block;line-height: 22px;border-radius: 100px;color: #fff;cursor:pointer;}
    .favorites .favorites_wrapper .category_list_sub ul li span i{color: #fff;font-size: 13px !important;width: 0px !important;position: relative;top: -2px;left: -2px;}
    .favorites .favorites_wrapper .category_list_sub ul li strong{font-weight:600;color:#0e3966;font-size:14px;}
    .favorites .favorites_wrapper .category_list_sub ul li small{ display:block;}
    
    /************* green ***************/
    
    .favorites .favorites_wrapper .category_list_sub.green h3 span{color:#85ba52;}
    .favorites .favorites_wrapper .category_list_sub.green h3 i{color: #84bc4d;}
    .favorites .favorites_wrapper .category_list_sub.green ul li:hover{background:#dbf2d6;}
    
    /************* blue ***************/
    
    .favorites .favorites_wrapper .category_list_sub.blue h3 span{color:#3c7eef;}
    .favorites .favorites_wrapper .category_list_sub.blue h3 i{color: #3c7eef;}
    .favorites .favorites_wrapper .category_list_sub.blue ul li:hover{background:#e4ecff;}
    
    /************* orange ***************/
    
    .favorites .favorites_wrapper .category_list_sub.orange h3 span{color:#f1a80b;}
    .favorites .favorites_wrapper .category_list_sub.orange h3 i{color: #f1a80b;}
    .favorites .favorites_wrapper .category_list_sub.orange ul li:hover{background:#fbefd6;}
    
    /************* sky ***************/
    
    .favorites .favorites_wrapper .category_list_sub.sky h3 span{color:#0bc4e0;}
    .favorites .favorites_wrapper .category_list_sub.sky h3 i{color: #0bc4e0;}
    .favorites .favorites_wrapper .category_list_sub.sky ul li:hover{background:#d4f8fd;}
    
    /************* red ***************/
    
    .favorites .favorites_wrapper .category_list_sub.red h3 span{color:#ff6634;}
    .favorites .favorites_wrapper .category_list_sub.red h3 i{color: #ff6634;}
    .favorites .favorites_wrapper .category_list_sub.red ul li:hover{background:#fce6df;}
    
    
    </style>